<div class="card-body">
    <div id="website-analytics-chart"></div>
</div>